import { Component } from 'react';

/**
 * RU: граница ошибок ВНУТРИ Pixi-дерева — копия ядровой (components/errorBoundary): пакет
 *     `pascal-slots-core` экспортирует только `Frame` (правило владельца 05.10).
 *
 * Без неё ошибка рендера под <Stage> разбирает весь React-root, @pixi/react на этом делает
 * app.destroy(): канвас чёрный, а императивные контроллеры игры продолжают работать с уже
 * уничтоженными объектами. Граница держит Application живым, а в консоль попадает один лог с
 * component stack. Fallback — null (рендер идёт через Pixi-реконсилятор, DOM нет).
 */
export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { name = 'PixiTree', onError } = this.props;
    const componentStack = errorInfo?.componentStack ?? '';
    console.error(
      `[ErrorBoundary:${name}] ${error?.message || error}\ncomponentStack:${componentStack}`,
      error
    );
    onError?.(error, componentStack);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default ErrorBoundary;
